import { customAxios } from './customAxios';

export async function updateSaleDiRiferimento(idSoggettoTerzo, saleDiRiferimento) {
    const config = {
        params: { saleDiRiferimento },
        headers: {
            Accept: '*/*',
            'AuthToken': JSON.parse(localStorage.getItem('token')),
        },
    };
    try {
        const response = await customAxios.put(
            `${process.env.REACT_APP_BACKEND_HOST}/adv/soggetti-terzi/${idSoggettoTerzo}/sale-di-riferimento`,
            null,
            config
        );
        return response.data;
    } catch (error) {
        console.error('Errore durante l\'aggiornamento della sale di riferimento:', error);
        throw error;
    }
}
